import { defineStore } from 'pinia'
import { Component, ref, shallowRef } from 'vue';

export const useDialog = defineStore('dialogStore', () => {
  const dialogContent = shallowRef<Component | undefined>(undefined);
  const dialogContentData = ref<any>(undefined);

  const dialogCloseEvent$: { value: ((res: any) => void) | undefined } = { value: undefined };

  // T: incomes data
  // R: return data (after close)
  function open<T, R>(componentType: Component, data: T) {
    dialogContent.value = componentType;
    dialogContentData.value = data;

    return new Promise((res: (value: R | undefined) => void) => dialogCloseEvent$.value = res);
  }

  function close(params?: any) {
    dialogContent.value = undefined;
    dialogCloseEvent$.value!(params);
  }

  return {
    dialogContent,
    dialogContentData,
    open,
    close,
  }
})
